import PropTypes from 'prop-types';

import { useMemo } from 'react';

import { Icon } from '@febos-io/design';

import { useTranslation } from '../hooks';
import { DOCUMENT_STATUS } from '../config/documentState';

export function DocumentStatus({ status = 'created' }) {
  const { t } = useTranslation();
  const { color, icon, message } = useMemo(
    () => DOCUMENT_STATUS[status] || DOCUMENT_STATUS.other,
    [status]
  );
  return (
    <div className={color}>
      <Icon icon={icon} className="me-1" />
      <strong className="text-uppercase">{t(`${message}`)}</strong>
    </div>
  );
}

export default DocumentStatus;

DocumentStatus.propTypes = {
  status: PropTypes.string.isRequired
};
